import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ApiStore } from '../../stores/ApiStore';
import { inject, bind } from '../../utils/decorators';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { IPublicDokument, IPublicAuftragResponse } from '../../models/ApiTypesPublic';
import FaIcon from '../site/FaIcon';
import Callout from '../site/Callout';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';

interface IDokumentePublicRouterProps {
  guid: string;
}

/**
 * Komponente für den Zugriff auf öffentlich freigegebene Dokumente zu einem Auftrag
 */
@observer
export default class DokumentePublic extends React.Component<RouteComponentProps<IDokumentePublicRouterProps>, {}> {

  @inject(ApiStore) apiStore: ApiStore;

  @observable docs: IPublicDokument[];
  @observable refnr: string = '';
  @observable error: string | undefined = undefined;
  @observable ergebnisAnfrage: boolean | undefined = undefined;
  @observable email: string = '';

  async componentDidMount() {
    const { guid } = this.props.match.params;
    let response = await this.apiStore.publicAuftragDokumente(guid);
    if (response.ok) {
      this.setData(response.json);
    } else {
      this.setError('Es konnte kein Auftrag mit der angegebenen Referenznummer gefunden werden!');
    }
  }

  @bind async handleButtonFolgeAuftragClick() {
    const { guid } = this.props.match.params;
    let response = await this.apiStore.publicAuftragAnfrageFolgeAuftrag(guid);
    this.setErgebnisAnfrage(response.ok);
  }

  @action setData(response: IPublicAuftragResponse) {
    this.docs = response.dokumente;
    this.refnr = response.refnr;
    this.error = undefined;
  }

  @action setError(error: string | undefined) {
    this.error = error;
  }

  @action setErgebnisAnfrage(ergebnis: boolean | undefined) {
    this.ergebnisAnfrage = ergebnis;
  }

  render() {
    const { guid } = this.props.match.params;
    return (
      <div className="kontakt">
        {
          this.error !== undefined ?
            (<Callout bsStyle="danger">{this.error}</Callout>)
          :
          this.docs &&
            (
              this.docs.length === 0 ?
              (
                <Callout bsStyle="default">
                  <p>Für diesen Auftrag wurden keine Qualifizierungsdokumente freigegeben.</p>
                  <p className="text-hint-light">Referenz: {guid}</p>
                </Callout>
              )
              :
              (
                <div className="maxwidth">
                  <h2>Freigegebene Dokumente zu Auftrag {this.refnr}</h2>
                  <Panel header="Verfügbare Dokumente">
                    <ListGroup fill={true}>
                      {this.docs.map((doc, index) =>
                        <ListGroupItem key={index} href={this.apiStore.publicAuftragDokumentDownloadUrl(guid, doc.eintrag_guid)} target="_blank">
                          <FaIcon icon="file-pdf-o" />{doc.titel}
                          <span className="pull-right text-hint-light">{doc.datum}</span>
                        </ListGroupItem>)}
                    </ListGroup>
                  </Panel>
                  {/* <Panel
                      header="Folgeauftrag anfragen"
                      bsStyle="info"
                      footer={(
                        <div className="text-right">
                          <Button onClick={() => { this.handleButtonFolgeAuftragClick(); }}><FaIcon icon="envelope-o" /> Unverbindlich anfragen</Button>
                        </div>
                      )}
                    >
                    <div>
                      <p>An dieser Stelle können sie schnell und einfach einen Folgeauftrag anfragen. Ein Mitarbeiter der DIQ Zert wird sich danach mit Ihnen in Verbindung setzen.</p>
                      {this.ergebnisAnfrage === true && <Callout bsStyle="success">Ihre Anfrage wurde erfolgreich übermittelt.</Callout>}
                      {this.ergebnisAnfrage === false && <Callout bsStyle="danger">Beim Übermitteln der Anfrage ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut oder wenden Sie sich direkt an <a href="mailto:info@diq-zert.de">info@diq-zert.de</a>.</Callout>}
                    </div>
                  </Panel> */}
                </div>
              )
            )
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/public/DokumentePublic.tsx